/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Print_Totalblocks1Inputs */

const zh_print_totalblocks1 = /** @type {(inputs: Print_Totalblocks1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 道题`)
};

const en_print_totalblocks1 = /** @type {(inputs: Print_Totalblocks1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} questions`)
};

const es_print_totalblocks1 = /** @type {(inputs: Print_Totalblocks1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} preguntas`)
};

/**
* | output |
* | --- |
* | "{count} questions" |
*
* @param {Print_Totalblocks1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const print_totalblocks1 = /** @type {((inputs: Print_Totalblocks1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Totalblocks1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_print_totalblocks1(inputs)
	if (locale === "en") return en_print_totalblocks1(inputs)
	return es_print_totalblocks1(inputs)
});
export { print_totalblocks1 as "print_totalBlocks" }